import { render, staticRenderFns } from "./ChipStatusIndicacao.vue?vue&type=template&id=79492a60&"
import script from "./ChipStatusIndicacao.vue?vue&type=script&lang=js&"
export * from "./ChipStatusIndicacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports